const settings = {
  // BACKEND_URL: "http://ec2-3-101-127-5.us-west-1.compute.amazonaws.com:5000",
  // BACKEND_URL: "http://localhost:5000",
  BACKEND_URL: "https://hazlo-api.hub.seraphic.io",
  // BACKEND_URL: "http://13.58.164.175:4040",
};

export default settings;